/*
 * @prettier
 * @copyright (c) 2019 - present, HGC-AB
 * @licence This source code is licensed under the MIT license described and found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Theme provider wrapper to be injected at the root element
 * The root element in Gatsby does not re-render on route changes
 */
import themeWrapper from './src/theme'

/**
 * Styles for prism
 */
//require('prismjs/themes/prism-okaidia.css')
require('./src/styles/prism-material-dark.css')
require('prismjs/plugins/line-numbers/prism-line-numbers.css')

/**
 * Inject themeProvider on the root element
 * @type {Function}
 */
export const wrapRootElement = themeWrapper

/**
 * Store referrer in gatsby location.state on route changes
 * @param location
 * @param prevLocation
 */
export const onRouteUpdate = ({ location, prevLocation }) => {
  if (location && location.state) {
    location.state.referrer = prevLocation ? prevLocation.pathname : null
  }
}
